var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V48C56 52.4183 52.4183 56 48 56H8C3.58172 56 0 52.4183 0 48V8Z",
    fill: "#D5C1FB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_182_173",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_182_173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1 36.25C20.15 35.3333 19.3958 34.2542 18.8375 33.0125C18.2792 31.7708 18 30.4333 18 29C18 27.6167 18.2625 26.3167 18.7875 25.1C19.3125 23.8833 20.025 22.825 20.925 21.925C21.825 21.025 22.8833 20.3125 24.1 19.7875C25.3167 19.2625 26.6167 19 28 19C29.3833 19 30.6833 19.2625 31.9 19.7875C33.1167 20.3125 34.175 21.025 35.075 21.925C35.975 22.825 36.6875 23.8833 37.2125 25.1C37.7375 26.3167 38 27.6167 38 29C38 30.4333 37.7208 31.775 37.1625 33.025C36.6042 34.275 35.85 35.35 34.9 36.25L33.5 34.85C34.2667 34.1167 34.875 33.2458 35.325 32.2375C35.775 31.2292 36 30.15 36 29C36 26.7667 35.225 24.875 33.675 23.325C32.125 21.775 30.2333 21 28 21C25.7667 21 23.875 21.775 22.325 23.325C20.775 24.875 20 26.7667 20 29C20 30.15 20.225 31.225 20.675 32.225C21.125 33.225 21.7417 34.0917 22.525 34.825L21.1 36.25ZM23.925 33.425C23.3417 32.875 22.875 32.2208 22.525 31.4625C22.175 30.7042 22 29.8833 22 29C22 27.3333 22.5833 25.9167 23.75 24.75C24.9167 23.5833 26.3333 23 28 23C29.6667 23 31.0833 23.5833 32.25 24.75C33.4167 25.9167 34 27.3333 34 29C34 29.8833 33.825 30.7083 33.475 31.475C33.125 32.2417 32.6583 32.8917 32.075 33.425L30.65 32C31.0667 31.6167 31.3958 31.1667 31.6375 30.65C31.8792 30.1333 32 29.5833 32 29C32 27.9 31.6083 26.9583 30.825 26.175C30.0417 25.3917 29.1 25 28 25C26.9 25 25.9583 25.3917 25.175 26.175C24.3917 26.9583 24 27.9 24 29C24 29.6 24.1208 30.1542 24.3625 30.6625C24.6042 31.1708 24.9333 31.6167 25.35 32L23.925 33.425ZM28 31C27.45 31 26.9792 30.8042 26.5875 30.4125C26.1958 30.0208 26 29.55 26 29C26 28.45 26.1958 27.9792 26.5875 27.5875C26.9792 27.1958 27.45 27 28 27C28.55 27 29.0208 27.1958 29.4125 27.5875C29.8042 27.9792 30 28.45 30 29C30 29.55 29.8042 30.0208 29.4125 30.4125C29.0208 30.8042 28.55 31 28 31Z",
    fill: "#8046F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.cd964ce8fa8586faeb92e3484bbea017.svg";
export { ForwardRef as ReactComponent };